<template>
  <div>
    <v-sheet class="transparent-background-color" v-show="!EditDefaultUnitsFlg">
      <v-card class="page-card">
        <v-row no-gutters class="ms-3" v-if="isView">
          <v-col>
            <v-tabs v-model="tab" height="64" background-color="transparent">
              <v-tab>
                <v-card-title class="pa-0">
                  {{ $t("CRUD.viewInfo", [$t("Material.ObjectName")]) }}
                </v-card-title>
              </v-tab>
              <v-tab
                v-if="$permission.permissionAllow('SupplierMaterials', 'index')"
              >
                <v-card-title class="pa-0">
                  {{ $t("Material.viewMaterialSupplierSet") }}
                </v-card-title>
              </v-tab>
              <v-tab
                v-if="
                  $permission.permissionAllow(
                    'StockMaterials',
                    'getMaterialStocks'
                  )
                "
              >
                <v-card-title class="pa-0">
                  {{ $t("Material.viewMaterialStockSet") }}
                </v-card-title>
              </v-tab>
            </v-tabs>
          </v-col>
          <v-card-title class="me-3">
            <v-tooltip left class="me-1">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  @click="
                    $emit('mode', null);
                    $emit('input', null);
                  "
                  >fa-times
                </v-icon>
              </template>
              <span>
                {{ $t("CRUD.backToList", [$t("Material.ObjectName")]) }}
              </span>
            </v-tooltip>
          </v-card-title>
        </v-row>
        <v-card-title class="mx-3" v-else>
          {{
            $t(
              isNew
                ? "CRUD.newInfo"
                : savable
                ? "CRUD.editInfo"
                : "CRUD.viewInfo",
              [$t("Material.ObjectName")]
            )
          }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $emit('mode', null);
                  $emit('input', null);
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("Material.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <ValidationObserver ref="observer">
                <v-row
                  align="center"
                  v-if="
                    (settings &&
                      settings.material_auto_code &&
                      settings.material_auto_code.auto_code == 1) ||
                    (settings && settings.material_auto_code == null) ||
                    (settings &&
                      settings.material_auto_code &&
                      settings.material_auto_code.auto_code == 2 &&
                      !isNew)
                  "
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Material.Fields.material_code") + $t("Global.colon")
                    }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-row align="center">
                      <v-col
                        :cols="
                          settings && settings.shop_inventory_enable && !isNew
                            ? '11'
                            : '12'
                        "
                      >
                        <v-text-field
                          v-if="
                            settings &&
                            settings.material_auto_code &&
                            settings.material_auto_code.auto_code == 2
                          "
                          single-line
                          v-model="material.material_code"
                          :hint="$t('Material.codeHint')"
                          disabled
                        >
                        </v-text-field>
                        <ValidationProvider
                          v-else
                          v-slot="{ errors }"
                          :name="$t('Material.Fields.material_code')"
                          rules="required"
                        >
                          <v-text-field
                            single-line
                            v-model="material.material_code"
                            :hint="isNew ? '' : $t('Material.codeHint')"
                            :error-messages="
                              $resparse
                                .getErrorMsgs(serverErrors, 'material_code')
                                .concat(errors)
                            "
                            :disabled="
                              settings &&
                              settings.shop_inventory_enable &&
                              !isNew &&
                              !codeEditFlg
                            "
                          >
                            <template v-slot:message="{ key, message }">
                              <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                              </div>
                            </template>
                          </v-text-field>
                        </ValidationProvider></v-col
                      >
                      <v-col
                        :cols="
                          settings && settings.shop_inventory_enable && !isNew
                            ? '1'
                            : '0'
                        "
                      >
                        <v-icon
                          v-if="
                            settings && settings.shop_inventory_enable && !isNew
                          "
                          x-small
                          @click.stop="checkEditAndDelete()"
                          class="pt-2 pb-1 primary--text"
                        >
                          fa-edit
                        </v-icon>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ material.material_code }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Material.Fields.material_name") + $t("Global.colon")
                    }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Material.Fields.material_name')"
                      rules="required"
                    >
                      <v-text-field
                        single-line
                        v-model="materialName"
                        :hint="isNew ? '' : $t('Material.nameHint')"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'material_name')
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ material.material_name }}
                  </v-col>
                </v-row>
                <!-- 商品第三方编码 -->
                <v-row
                  align="center"
                  v-if="settings && settings.material_ext_code_enable"
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Material.Fields.ext_code") + $t("Global.colon") }}
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field single-line v-model="material.ext_code">
                    </v-text-field>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ material.ext_code }}
                  </v-col>
                </v-row>
                <!-- 商品默认图片 -->
                <v-row>
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Material.Fields.material_img") + $t("Global.colon")
                    }}
                    <Required :show="false" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7">
                    <v-card v-if="material_img" max-width="240">
                      <v-img
                        :src="material_img"
                        @click.stop="$showFullscreenImages([material_img])"
                      >
                        <v-tooltip right v-if="savable && material_img">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              color="danger"
                              class="pa-2 float-right"
                              @click.stop="
                                !material_img.startsWith('data:image/') &&
                                material_img == material.material_img
                                  ? (material.material_img = material_img =
                                      null)
                                  : (material_img = null);
                                material.thumbnail = null;
                              "
                            >
                              fa-times
                            </v-icon>
                          </template>
                          <span> {{ $t("Material.delImg") }}</span>
                        </v-tooltip>
                      </v-img>
                    </v-card>
                    <v-file-input
                      ref="material_img_file"
                      v-if="savable"
                      show-size
                      prepend-icon="fa-camera"
                      accept="image/png, image/jpeg"
                      persistent-hint
                      :placeholder="$t('Material.imgPlaceholder')"
                      :hint="$t('Material.imgSquareHint')"
                      :rules="imgRules"
                      v-model="material_img_file"
                    >
                    </v-file-input>
                  </v-col>
                </v-row>
                <!-- 商品图片集 -->
                <v-row>
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Material.Fields.material_album") + $t("Global.colon")
                    }}
                    <Required :show="false" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7">
                    <v-card
                      height="320"
                      v-if="material_album && material_album.length > 0"
                    >
                      <v-carousel hide-delimiters cycle height="320">
                        <v-carousel-item
                          v-for="(item, i) in material_album"
                          :key="i"
                          :src="item"
                          @click.stop="$showFullscreenImages(material_album, i)"
                        >
                          <v-tooltip right v-if="savable && material_album">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                color="danger"
                                class="pa-2 float-right"
                                @click.stop="removeFromImages(i)"
                              >
                                fa-times
                              </v-icon>
                            </template>
                            <span> {{ $t("Material.delImg") }}</span>
                          </v-tooltip>
                        </v-carousel-item>
                      </v-carousel>
                    </v-card>
                    <v-file-input
                      ref="material_imgs_file"
                      v-if="savable"
                      show-size
                      counter
                      small-chips
                      multiple
                      suffix
                      prepend-icon="fa-camera"
                      accept="image/png, image/jpeg"
                      persistent-hint
                      :placeholder="$t('Material.imgsPlaceholder')"
                      :hint="$t('Material.imgsHint')"
                      :rules="imgsRules"
                      v-model="material_imgs_file"
                    >
                    </v-file-input>
                  </v-col>
                  <v-col
                    class="float-right"
                    v-if="
                      savable && material_album && material_album.length > 0
                    "
                  >
                    <v-btn
                      color="primary"
                      x-small
                      @click.stop="
                        material_album = [];
                        material.material_album = [];
                      "
                    >
                      {{ $t("Material.Fields.clear_all_imgs") }}
                    </v-btn>
                    <br />
                    <v-btn
                      class="mt-2"
                      color="primary"
                      x-small
                      @click.stop="downloadAlbumImgs()"
                    >
                      {{ $t("Material.Fields.download_all_imgs") }}
                    </v-btn>
                  </v-col>
                  <v-col
                    v-else-if="
                      !savable && material_album && material_album.length > 0
                    "
                  >
                    <v-btn
                      color="primary"
                      x-small
                      @click.stop="downloadAlbumImgs()"
                    >
                      {{ $t("Material.Fields.download_all_imgs") }}
                    </v-btn>
                  </v-col>
                </v-row>
                <!-- 商品视频 -->
                <v-row v-if="settings && settings.material_video">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Material.Fields.material_video") + $t("Global.colon")
                    }}
                    <Required :show="false" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7">
                    <v-card
                      v-if="material_video"
                      max-width="240"
                      max-height="160"
                    >
                      <div max-width="240" style="position: relative">
                        <span
                          style="
                            position: absolute;
                            top: 0;
                            right: 0;
                            z-index: 99;
                          "
                          @click.stop="
                            material_video = material.material_video = null
                          "
                          v-if="savable && material_video"
                        >
                          <v-icon color="secondary" class="pa-2 float-right">
                            fa-times
                          </v-icon>
                        </span>
                        <video width="240" height="160" controls>
                          <source :src="material_video" />
                        </video>
                      </div>
                    </v-card>
                    <v-file-input
                      ref="material_video_file"
                      v-if="savable"
                      show-size
                      prepend-icon="fa-camera"
                      accept="video/mp4,video/avi,video/wmv,video/mpeg,video/mov,video/flv,video/f4v,video/rmvb"
                      persistent-hint
                      :placeholder="$t('Material.videoPlaceholder')"
                      v-model="material_video_file"
                    >
                    </v-file-input>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Material.Fields.material_category") +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Material.Fields.material_category')"
                      rules="required"
                    >
                      <SearcherMaterialCategory
                        v-model="material.material_category"
                        no-label
                        unclearable
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'category_code')
                            .concat(errors)
                        "
                      />
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{
                      material && material.material_category
                        ? material.material_category.name
                        : ""
                    }}
                  </v-col>
                </v-row>
                <v-row
                  align="center"
                  v-if="
                    settings &&
                    settings.miniprogram &&
                    (settings.miniprogram.template_id == '4' ||
                      settings.miniprogram.template_id == '3')
                  "
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Material.Fields.material_show_categories") +
                      $t("Global.colon")
                    }}
                    <Required :show="false" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <SearcherMaterialShowCategories
                      v-model="material.show_categories"
                      no-label
                    />
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    <v-chip
                      v-for="show_category in material.show_categories"
                      :key="show_category.id"
                      small
                      label
                      outlined
                      color="info"
                      class="me-1"
                    >
                      {{
                        show_category.parent_show_category
                          ? show_category.parent_show_category.name + " : "
                          : ""
                      }}
                      {{ show_category.name }}
                    </v-chip>
                  </v-col>
                </v-row>
                <v-row
                  align="center"
                  v-if="settings && settings.material_group_enable"
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Material.Fields.material_group") + $t("Global.colon")
                    }}
                    <Required :show="false" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-combobox
                      ref="material_group"
                      v-model="material.material_group"
                      :items="material_groups"
                    />
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ material.material_group }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Material.Fields.expand_1") + $t("Global.colon") }}
                    <Required :show="false" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field single-line v-model="material.expand_1" />
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ material.expand_1 }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Material.Fields.pinyin") + $t("Global.colon") }}
                    <Required :show="false" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field single-line v-model="material.pinyin" />
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ material.pinyin }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Material.Fields.material_sname") + $t("Global.colon")
                    }}
                    <Required :show="false" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field
                      single-line
                      v-model="material.material_sname"
                    />
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ material.material_sname }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Material.Fields.sort") + $t("Global.colon") }}
                    <Required :show="false" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field
                      single-line
                      v-model="material.sort"
                      type="number"
                      min="0"
                      :hint="$t('Material.sortHint')"
                      @blur="
                        material.sort = $numberFormatter.formatNoDot(
                          material.sort
                        )
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ material.sort }}
                    <span class="ms-3 caption grey--text text--disabled">
                      {{ $t("Material.sortHint") }}
                    </span>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Material.Fields.origin") + $t("Global.colon") }}
                    <Required :show="false" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-combobox
                      ref="material_origin"
                      v-model="material.origin"
                      :items="material_origins"
                    />
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ material.origin }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Material.Fields.brand") + $t("Global.colon") }}
                    <Required :show="false" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-combobox
                      ref="material_brand"
                      v-model="material.brand"
                      :items="material_brands"
                    />
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ material.brand }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right"
                    >{{
                      $t("Material.Fields.storage_conditions") +
                      $t("Global.colon")
                    }}
                    <Required :show="false" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-combobox
                      ref="storage_conditions"
                      v-model="material.storage_conditions"
                      :items="material_storage_conditions"
                    />
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ material.storage_conditions }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Material.Fields.standard") + $t("Global.colon") }}
                    <Required :show="false" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field
                      single-line
                      v-if="material && material.standard"
                      v-model="material.standard.name"
                    />
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{
                      material && material.standard
                        ? material.standard.name
                        : ""
                    }}
                  </v-col>
                </v-row>
                <v-row class="d-none" align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Material.Fields.barcode") + $t("Global.colon") }}
                    <Required :show="false" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field
                      single-line
                      v-if="material && material.standard"
                      v-model="material.standard.barcode"
                    />
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{
                      material && material.standard
                        ? material.standard.barcode
                        : ""
                    }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Material.Fields.unit") + $t("Global.colon") }}
                    <Required :show="savable" :mode="mode" />
                    <br />
                    <v-btn
                      v-if="savable && material.id"
                      color="primary"
                      class="my-1"
                      small
                      @click="editUnit = !editUnit"
                    >
                      {{
                        editUnit
                          ? $t("Global.cancel")
                          : $t("Material.units.edit")
                      }}
                    </v-btn>
                    <br />
                  </v-col>
                  <v-col v-if="material.standard" cols="9">
                    <v-row dense class="pr-1">
                      <v-col
                        v-for="(item, index) in material.standard
                          .standard_details"
                        :key="item.unit"
                        cols="12"
                        sm="6"
                      >
                        <StandardDetail
                          :mode="mode"
                          :editUnit="editUnit"
                          v-model="material.standard.standard_details[index]"
                          :default-unit="
                            material.standard.default_standard_detail.unit
                          "
                          :server-errors="
                            $resparse.getErrors(
                              serverErrors,
                              'standard.standard_details'
                            )
                          "
                          @delete="deleteUnit(index)"
                          @make-defalut="changeDefaultUnit(item)"
                        />
                      </v-col>
                      <v-col cols="12" sm="6" v-if="savable && editUnit">
                        <v-card>
                          <v-list dense>
                            <v-list-item>
                              <v-list-item-content class="text-subtitle-1">
                                <EditorUnit
                                  v-model="addUnit"
                                  :disabled-items="
                                    material.standard &&
                                    material.standard.standard_details
                                      ? material.standard.standard_details.map(
                                          (standard_detail) =>
                                            standard_detail.unit
                                        )
                                      : null
                                  "
                                />
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row
                  align="center"
                  v-if="settings && settings.shop_inventory_enable"
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Material.Fields.raw_material_flg") +
                      $t("Global.colon")
                    }}
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-row align="center">
                      <v-col cols="4">
                        <v-radio-group row v-model="material.raw_material_flg">
                          <v-radio
                            :label="$t('Material.raw_material_flg.on')"
                            :key="1"
                            :value="1"
                          />
                          <v-radio
                            :label="$t('Material.raw_material_flg.off')"
                            :key="0"
                            :value="0"
                          />
                        </v-radio-group>
                      </v-col>
                      <v-col
                        cols="8"
                        v-if="
                          savable &&
                          material.raw_material_flg == 1 &&
                          Object.keys(material.standard.default_standard_detail)
                            .length
                        "
                      >
                        <a
                          class="text-wrap"
                          style="text-decoration: none"
                          @click="checkEditCostUnit('word')"
                        >
                          {{ $t("Material.Fields.default_cost_unit") }}
                        </a>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{
                      material.raw_material_flg == 1
                        ? $t("Material.raw_material_flg.on")
                        : $t("Material.raw_material_flg.off")
                    }}
                  </v-col>
                </v-row>
                <v-row
                  align="center"
                  v-if="
                    settings &&
                    settings.shop_inventory_enable &&
                    material.raw_material_flg
                  "
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Material.Fields.cost_unit_and_rate") +
                      $t("Global.colon")
                    }}
                    <Required
                      :show="savable && material.raw_material_flg"
                      :mode="mode"
                    />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-row>
                      <v-col cols="4">
                        <div class="d-flex">
                          <span class="mt-3">
                            {{
                              $t("Material.costUnitHint") + $t("Global.colon")
                            }}
                          </span>

                          <!-- {{ material.cost_unit }} -->
                          <!-- 新增商品或者编辑商品并且校验用过可编辑成本单位 -->
                          <ValidationProvider
                            v-slot="{ errors }"
                            v-if="
                              mode == 'new' ||
                              (mode == 'edit' && costUnitEditFlg == true) ||
                              mode == 'clone'
                            "
                            :name="$t('Material.costUnitHint')"
                            rules="required"
                          >
                            <v-text-field
                              v-model="material.cost_unit"
                              dense
                              style="max-width: 120px"
                              :error-messages="errors"
                            >
                            </v-text-field>
                          </ValidationProvider>
                          <span v-else class="mt-3">
                            {{ material.cost_unit }}
                            <v-icon
                              x-small
                              @click.stop="checkEditCostUnit('editPen')"
                              class="pt-2 pb-1 primary--text ml-2"
                            >
                              fa-edit
                            </v-icon>
                          </span>
                        </div>
                      </v-col>
                      <!-- <v-col>
                        <v-combobox
                          ref="cost_unit"
                          :label="$t('Material.costUnitHint')"
                          v-model="material.cost_unit"
                          :items="material_cost_unit"
                          dense
                        />
                      </v-col> -->
                      <v-col>
                        <v-text-field
                          v-model="material.cost_unit_rate"
                          :label="$t('Material.costUnitRateHint')"
                          type="number"
                          min="0"
                          dense
                          @blur="
                            material.cost_unit_rate =
                              $numberFormatter.formatMoney(
                                material.cost_unit_rate
                              )
                          "
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    <span class="mr-3">
                      {{
                        material.cost_unit +
                        "(" +
                        $t("Material.costUnitHint") +
                        ")"
                      }}
                    </span>
                    <span class="mx-3">
                      {{
                        material.cost_unit_rate +
                        "(" +
                        $t("Material.costUnitRateHint") +
                        ")"
                      }}
                    </span>
                  </v-col>
                </v-row>
                <v-row
                  align="center"
                  v-if="
                    settings &&
                    settings.shop_inventory_enable &&
                    material.raw_material_flg
                  "
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Material.Fields.net_rate") + $t("Global.colon") }}
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field
                      v-model="material.net_rate"
                      type="number"
                      min="0"
                      dense
                      @blur="
                        material.net_rate =
                          $numberFormatter.formatWithDotNoMoreThan(
                            Number(material.net_rate),
                            2
                          )
                      "
                    />
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ material.net_rate }}
                  </v-col>
                </v-row>
                <v-row
                  align="center"
                  v-if="
                    settings &&
                    settings.shop_inventory_enable &&
                    material.raw_material_flg
                  "
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Material.Fields.yield") + $t("Global.colon") }}
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field
                      v-model="material.yield"
                      type="number"
                      min="0"
                      dense
                      @blur="
                        material.yield =
                          $numberFormatter.formatWithDotNoMoreThan(
                            Number(material.yield),
                            2
                          )
                      "
                    />
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ material.yield }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Material.Fields.in_price") + $t("Global.colon") }}
                    <Required :show="false" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field
                      single-line
                      v-model="material.in_price"
                      type="number"
                      min="0"
                      @blur="
                        material.in_price = $numberFormatter.formatMoney(
                          material.in_price
                        )
                      "
                      :prefix="$t('Global.money')"
                    />
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ $t("Global.money") }} {{ material.in_price }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t(
                        "Material.Fields.supply_unit_default",
                        $store.state.settings
                          ? [$store.state.settings.shop_custom_name]
                          : []
                      ) + $t("Global.colon")
                    }}
                    <Required :show="true" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="
                        $t(
                          'Material.Fields.supply_unit_default',
                          $store.state.settings
                            ? [$store.state.settings.shop_custom_name]
                            : []
                        )
                      "
                      rules="required"
                    >
                      <v-select
                        v-model="material.supply_standard_detail"
                        :items="
                          material.standard
                            ? material.standard.standard_details
                            : []
                        "
                        item-text="unit"
                        return-object
                        item-disabled="status"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(
                              serverErrors,
                              'standard.supply_standard_detail'
                            )
                            .concat(errors)
                        "
                      ></v-select>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{
                      material && material.supply_standard_detail
                        ? material.supply_standard_detail.unit
                        : ""
                    }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t(
                        "Material.Fields.supply_price_default",
                        $store.state.settings
                          ? [$store.state.settings.shop_custom_name]
                          : []
                      ) + $t("Global.colon")
                    }}
                    <Required :show="true" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="
                        $t(
                          'Material.Fields.supply_price_default',
                          $store.state.settings
                            ? [$store.state.settings.shop_custom_name]
                            : []
                        )
                      "
                      :rules="{
                        min_value: { min: 0 },
                        required: { required: true },
                      }"
                    >
                      <v-text-field
                        single-line
                        v-model="material.supply_price"
                        type="number"
                        min="0"
                        @blur="
                          material.supply_price = $numberFormatter.formatMoney(
                            material.supply_price
                          )
                        "
                        :error-messages="errors"
                        :prefix="$t('Global.money')"
                      />
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ $t("Global.money") }} {{ material.supply_price }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Material.Fields.supply_multiple_default") +
                      $t("Global.colon")
                    }}
                    <Required :show="false" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field
                      single-line
                      v-model="material.multiple"
                      type="number"
                      min="0"
                      @blur="
                        material.multiple =
                          $numberFormatter.formatWithDotNoMoreThan(
                            material.multiple,
                            2
                          )
                      "
                      :suffix="$t('Material.multipleEndfix')"
                    />
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ material.multiple }}
                    {{ $t("Material.multipleEndfix") }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Material.Fields.supply_min_default") +
                      $t("Global.colon")
                    }}
                    <Required :show="false" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field
                      single-line
                      v-model="material.min"
                      type="number"
                      min="0"
                      @blur="
                        material.min = $numberFormatter.formatWithDotNoMoreThan(
                          material.min,
                          2
                        )
                      "
                    />
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ material.min }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Material.Fields.supply_max_default") +
                      $t("Global.colon")
                    }}
                    <Required :show="false" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field
                      single-line
                      v-model="material.max"
                      type="number"
                      min="0"
                      @blur="
                        material.max = $numberFormatter.formatWithDotNoMoreThan(
                          material.max,
                          2
                        )
                      "
                    />
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ material.max }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Material.Fields.bestbefore") + $t("Global.colon") }}
                    <Required
                      :show="settings && settings.material_force_bestbefore"
                      :mode="mode"
                    />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-if="settings && settings.material_force_bestbefore"
                      v-slot="{ errors }"
                      :name="$t('Material.Fields.bestbefore')"
                      rules="required"
                    >
                      <v-text-field
                        single-line
                        v-model="material.bestbefore"
                        type="number"
                        @blur="
                          material.bestbefore = material.bestbefore
                            ? $numberFormatter.formatWithDotNoMoreThan(
                                material.bestbefore,
                                1
                              )
                            : ''
                        "
                        :suffix="$t('Material.bestbefore.days')"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'bestbefore')
                            .concat(errors)
                        "
                      />
                    </ValidationProvider>
                    <v-text-field
                      v-else
                      single-line
                      v-model="material.bestbefore"
                      type="number"
                      @blur="
                        material.bestbefore = material.bestbefore
                          ? $numberFormatter.formatWithDotNoMoreThan(
                              material.bestbefore,
                              1
                            )
                          : ''
                      "
                      :suffix="$t('Material.bestbefore.days')"
                    />
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ material.bestbefore }}
                    {{ $t("Material.bestbefore.days") }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Material.Fields.nearday") + $t("Global.colon") }}
                    <Required :show="false" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field
                      single-line
                      v-model="material.nearday"
                      type="number"
                      min="0"
                      @blur="
                        material.nearday =
                          $numberFormatter.formatWithDotNoMoreThan(
                            material.nearday,
                            1
                          )
                      "
                      :suffix="$t('Material.nearday.days')"
                    />
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ material.nearday }}
                    {{ $t("Material.nearday.days") }}
                  </v-col>
                </v-row>
                <v-row
                  align="center"
                  v-if="settings && settings.product_date_setting"
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Material.Fields.stock_batch_rule_type") +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-radio-group row v-model="material.stock_batch_rule_type">
                      <v-radio
                        :label="$t('Material.stockBatchRuleTypes.1')"
                        :key="1"
                        :value="1"
                      />
                      <v-radio
                        :label="$t('Material.stockBatchRuleTypes.2')"
                        :key="2"
                        :value="2"
                      />
                    </v-radio-group>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{
                      material.stock_batch_rule_type == 1
                        ? $t("Material.stockBatchRuleTypes.1")
                        : $t("Material.stockBatchRuleTypes.2")
                    }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Material.Fields.hide_flg") + $t("Global.colon") }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-radio-group row v-model="material.hide_flg">
                      <v-radio
                        :label="$t('Material.hideFlgs.off')"
                        :key="0"
                        :value="0"
                      />
                      <v-radio
                        :label="$t('Material.hideFlgs.on')"
                        :key="1"
                        :value="1"
                      />
                    </v-radio-group>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    <v-chip
                      small
                      label
                      dark
                      :color="material.hide_flg ? 'grey' : 'primary'"
                    >
                      {{
                        material.hide_flg
                          ? $t("Material.hideFlgs.on")
                          : $t("Material.hideFlgs.off")
                      }}
                    </v-chip>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Material.Fields.alcohol_flg") + $t("Global.colon") }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-radio-group row v-model="material.alcohol_flg">
                      <v-radio
                        :label="$t('Material.alcoholFlg.off')"
                        :key="0"
                        :value="0"
                      />
                      <v-radio
                        :label="$t('Material.alcoholFlg.on')"
                        :key="1"
                        :value="1"
                      />
                    </v-radio-group>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    <v-chip
                      small
                      label
                      dark
                      :color="material.alcohol_flg ? 'grey' : 'primary'"
                    >
                      {{
                        material.alcohol_flg
                          ? $t("Material.alcoholFlg.on")
                          : $t("Material.alcoholFlg.off")
                      }}
                    </v-chip>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Material.Fields.public_flg") + $t("Global.colon") }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-radio-group row v-model="material.public_flg">
                      <v-radio
                        :label="$t('Material.publicFlgs.off')"
                        :key="0"
                        :value="0"
                      />
                      <v-radio
                        :label="$t('Material.publicFlgs.on')"
                        :key="1"
                        :value="1"
                      />
                    </v-radio-group>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    <v-chip
                      small
                      label
                      dark
                      :color="material.public_flg ? 'primary' : 'grey'"
                    >
                      {{
                        material.public_flg
                          ? $t("Material.publicFlgs.on")
                          : $t("Material.publicFlgs.off")
                      }}
                    </v-chip>
                  </v-col>
                </v-row>
                <v-row
                  align="center"
                  v-if="settings && settings.production_module"
                >
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Material.Fields.production_attribute") +
                      $t("Global.colon")
                    }}
                    <Required :show="false" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7">
                    <v-row no-gutters class="ms-0" align="center">
                      <v-switch
                        v-model="material.production_attribute"
                        :disabled="!savable"
                        :true-value="1"
                        :false-value="0"
                        :label="
                          material.production_attribute
                            ? $t('Material.productionAttributes.on')
                            : $t('Material.productionAttributes.off')
                        "
                      />
                      <v-btn
                        color="primary"
                        class="ms-8"
                        small
                        v-show="material.production_attribute"
                        :disabled="!material.production_attribute"
                        @click="combineFormulaDialog = true"
                      >
                        {{ $t("Material.Fields.combine_formula") }}
                        <Formula
                          v-model="material.combine_formula_json"
                          combine
                          :materialName="material.material_name"
                          :defaultUnit="
                            material.standard.default_standard_detail.unit
                          "
                          :mode="mode"
                          :show="combineFormulaDialog"
                          @close="combineFormulaDialog = false"
                        />
                      </v-btn>
                      <v-btn
                        color="primary"
                        class="ms-4"
                        small
                        v-show="material.production_attribute"
                        :disabled="!material.production_attribute"
                        @click="splitFormulaDialog = true"
                      >
                        {{ $t("Material.Fields.split_formula") }}
                        <Formula
                          v-model="material.split_formula_json"
                          split
                          :materialName="material.material_name"
                          :defaultUnit="
                            material.standard.default_standard_detail.unit
                          "
                          :mode="mode"
                          :show="splitFormulaDialog"
                          @close="splitFormulaDialog = false"
                        />
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Material.Fields.template_setting") +
                      $t("Global.colon")
                    }}
                    <Required :show="false" :mode="mode" />
                  </v-col>
                  <!-- material.standard.standard_details.length &&
                      typeof material.multiple == 'number'
                        ? (templatesDialog = true)
                        : (newMaterialBindTemplatesDialog = true) -->
                  <v-btn
                    color="primary"
                    class="my-1"
                    small
                    @click="isNew ? click() : (templatesDialog = true)"
                  >
                    {{ $t("Material.Fields.template_setting") }}
                  </v-btn>
                </v-row>
                <v-row :class="savable ? 'mt-5' : ''">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Material.Fields.description") + $t("Global.colon") }}
                    <Required :show="false" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="9" v-if="savable">
                    <v-textarea
                      v-model="material.description"
                      outlined
                      auto-grow
                    />
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ material.description }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Material.Fields.video") + $t("Global.colon") }}
                    <Required :show="false" :mode="mode" />
                  </v-col>
                  <v-col cols="9" v-show="savable">
                    <v-textarea
                      v-model="material.video"
                      outlined
                      auto-grow
                      rows="3"
                      :hint="$t('Material.videoHint')"
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-textarea>
                  </v-col>
                  <v-col cols="9" v-show="!savable" id="material-video"></v-col>
                </v-row>
                <v-row>
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Material.Fields.comment") + $t("Global.colon") }}
                    <Required :show="false" :mode="mode" />
                  </v-col>
                  <v-col cols="9" v-show="savable">
                    <VEditor v-model="material.comment" />
                  </v-col>
                  <v-col cols="9" v-show="!savable && material.comment">
                    <v-card
                      outlined
                      class="pa-1"
                      id="material-comment"
                    ></v-card>
                  </v-col>
                </v-row>
              </ValidationObserver>
            </v-tab-item>
            <v-tab-item
              v-if="$permission.permissionAllow('SupplierMaterials', 'index')"
            >
              <v-data-table
                :headers="headers"
                :items="supplierMaterials"
                :options.sync="options"
                :page.sync="paging.page"
                :server-items-length="paging.count"
                :loading="loading"
                multi-sort
                :footer-props="$t('$config.footer-props')"
              >
                <template v-slot:header.actions="{ header }">
                  {{ header.text }}
                  <v-icon x-small>fa-sliders-h</v-icon>
                </template>
                <template v-slot:item.supply_price="{ item }">
                  {{ $t("Global.money") }} {{ item.supply_price | formatMoney }}
                </template>
                <template v-slot:item.tax_flg="{ item }">
                  <v-chip
                    small
                    label
                    :color="item.tax_flg ? 'primary' : 'grey'"
                    text-color="white"
                  >
                    {{
                      item.public_flg
                        ? $t("SupplierMaterials.Fields.tax_on")
                        : $t("SupplierMaterials.Fields.tax_off")
                    }}
                  </v-chip>
                </template>
                <template v-slot:item.tax_setting="{ item }">
                  <span v-if="item.tax_flg">
                    {{ item.tax_rate | formatWithDotNoMoreThan(2) }} %
                  </span>
                  <span v-else>-</span>
                </template>
                <template v-slot:item.default_supplier_flg="{ item }">
                  <v-checkbox
                    v-model="item.default_supplier_flg"
                    @click.stop="
                      settingDefaultSupplierDetail = item;
                      settingDefaultSupplierMsg =
                        item.material.default_supplier_id == item.supplier_id
                          ? $t(
                              'SupplierMaterials.cancelSettingDefaultSupplierMessage',
                              [item.supplier.supplier_name]
                            )
                          : $t(
                              'SupplierMaterials.settingDefaultSupplierMessage',
                              [item.supplier.supplier_name]
                            );
                      settingDefaultSupplierDialog = true;
                    "
                  ></v-checkbox>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-btn
                    small
                    color="primary"
                    :href="'/#/supplier/supplier-materials/' + item.supplier.id"
                    class="px-2 me-2 mb-1"
                  >
                    {{ $t("CRUD.viewInfo", [$t("SupplierMaterials.objName")]) }}
                  </v-btn>
                </template>
              </v-data-table>
            </v-tab-item>
            <v-tab-item
              v-if="
                $permission.permissionAllow(
                  'StockMaterials',
                  'getMaterialStocks'
                )
              "
            >
              <v-data-table
                :headers="materialStocksHeaders"
                :items="materialStocks"
                :options.sync="materialStocksOptions"
                :page.sync="materialStocksPaging.page"
                :server-items-length="materialStocksPaging.count"
                :loading="loading"
                multi-sort
                :footer-props="$t('$config.footer-props')"
              >
                <template v-slot:item.stock.name="{ item }">
                  {{ item.stock.code }} / {{ item.stock.name }}
                </template>
                <template v-slot:item.stock.type="{ item }">
                  <v-chip v-if="item.stock.type == 0" small label>
                    {{ $t("Stock.type.real") }}
                  </v-chip>
                  <v-chip v-if="item.stock.type == 1" small label>
                    {{ $t("Stock.type.v_auto") }}
                  </v-chip>
                  <v-chip v-if="item.stock.type == 2" small label>
                    {{ $t("Stock.type.v_manual") }}
                  </v-chip>
                </template>
                <template v-slot:item.stock_max="{ item }">
                  <v-row dense class="my-3">
                    <v-col class="mt-3">
                      <span class="pt-n1 text-no-wrap caption">
                        {{
                          $t("StockMaterials.Fields.max_num") +
                          $t("Global.colon")
                        }}
                        {{ item.stock_max }}
                      </span>
                    </v-col>
                  </v-row>
                  <v-row dense class="my-3">
                    <v-col class="mt-3">
                      <span class="pt-n1 text-no-wrap caption">
                        {{
                          $t("StockMaterials.Fields.min_num") +
                          $t("Global.colon")
                        }}
                        {{ item.stock_min }}
                      </span>
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:item.status="{ item }">
                  <div class="d-flex mt-n2 mb-n3">
                    <v-checkbox
                      color="primary"
                      v-model="item.status"
                      :true-value="1"
                      :false-value="0"
                      disabled
                    >
                      <template v-slot:label>
                        <span class="caption ms-n2">
                          {{
                            $t(
                              item.status
                                ? "StockMaterials.Fields.use_on"
                                : "StockMaterials.Fields.use_off"
                            )
                          }}
                        </span>
                      </template>
                    </v-checkbox>
                  </div>
                </template>
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <v-btn
                outlined
                color="secondary"
                class="elevation-1"
                block
                @click="
                  $emit('input', null);
                  $emit('mode', null);
                  $emit('save');
                "
              >
                <v-icon small class="pe-1">fa-times</v-icon>
                {{ $t("CRUD.backToList", [$t("Material.ObjectName")]) }}
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              v-if="isView && $permission.permissionAllow('Materials', 'edit')"
            >
              <v-btn
                color="accent"
                block
                :disabled="loading && !material.id"
                @click="$emit('mode', 'edit')"
              >
                <v-icon small class="pe-1">fa-pencil-alt</v-icon>
                {{ $t("CRUD.editInfo", [$t("Material.ObjectName")]) }}
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              v-if="
                isView &&
                $permission.permissionAllow('Materials', 'editDefaultUnit')
              "
            >
              <v-btn
                color="orange"
                dark
                block
                :disabled="loading && !material.id"
                @click="
                  getEditDefaultUnits();
                  editMaterial = JSON.parse(JSON.stringify(material));
                "
              >
                <v-icon small class="pe-1">fa-edit</v-icon>
                {{ $t("Material.editDefaultUnits") }}
              </v-btn>
            </v-col>
            <v-col cols="12" v-if="savable">
              <v-btn
                color="success"
                block
                :disabled="(loading && !material.id) || isUploading"
                @click="
                  backFlg = false;
                  preSubmit();
                "
              >
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("CRUD.saveInfo", [$t("Material.ObjectName")]) }}
              </v-btn>
            </v-col>
            <v-col cols="12" v-if="savable && settings.new_material_add != 0">
              <v-btn
                color="success"
                block
                :disabled="(loading && !material.id) || isUploading"
                @click="
                  backFlg = true;
                  preSubmit();
                "
              >
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("CRUD.saveInfoBack", [$t("Material.ObjectName")]) }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>

    <DialogAlert
      v-model="settingDefaultSupplierDialog"
      :message="settingDefaultSupplierMsg"
      useConfirm
      @cancel="
        settingDefaultSupplierDetail.default_supplier_flg =
          !settingDefaultSupplierDetail.default_supplier_flg
      "
      @confirm="settingDefaultSupplier()"
    />
    <TemplatesSelectsDialog
      v-model="templatesDialog"
      :savable="savable"
      :material="material"
      :templatesMaterial="templatesMaterial"
      :isNew="isNew"
      :templates="templates"
      @templateDetails="templates = $event"
      @close="resetTemplates()"
    />
    <DialogAlert
      v-model="newMaterialBindTemplatesDialog"
      :message="$t('Material.templates.settingDefaultSupplierMsg')"
    />

    <EditDefaultUnits
      v-show="EditDefaultUnitsFlg"
      v-model="EditDefaultUnitsFlg"
      :editMaterial="editMaterial"
    />
    <DialogStocks
      v-model="stocks_dialog"
      :stockSelected="stocks"
      @confirm="
        stocks = $event;
        submit(backFlg);
        stocks_dialog = false;
      "
      :types="[0]"
      :status="[1]"
    />
    <ErrorShopDialog v-model="errorDataDialog" :errorData="error_data" />

    <v-dialog v-model="foodFormulasDialog" width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("CRUD.info", [$t("Recipes.ObjectName")]) }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="foodFormulasDialog = false"
              >
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <!-- <v-card-text class="px-4 py-8 text-center subtitle-1"> -->
        <v-data-table
          :headers="foodFormulasHeaders"
          :items="costUnitCheckData.food_formulas"
          multi-sort
          class="elevation-0 px-4 pt-2"
          disable-pagination
          hide-default-footer
          fixed-header
        >
          <template v-slot:top>
            <v-toolbar
              flat
              class="transparent-background-color"
              align-self="center"
              v-if="costUnitCheckData.batch_delete_Formula_flg == 1"
            >
              <v-row no-gutters class="me-n3">
                <v-row no-gutters>
                  <v-spacer />
                  <v-btn color="error" @click="foodFormulasDel()" dense small>
                    {{ $t("Recipes.Fields.batch_delete_for_materials") }}
                  </v-btn>
                </v-row>
              </v-row>
            </v-toolbar>
          </template>
          <template v-slot:item.delete_flg="{ item }">
            <span v-if="item.delete_flg == 1">
              {{ $t("Recipes.Fields.on") }}
            </span>
            <span v-else>
              {{ $t("Recipes.Fields.off") }}
            </span>
          </template>
        </v-data-table>
        <!-- </v-card-text>  -->
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="foodFormulasDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import VEditor from "@/plugins/VEditor";
import Required from "@/components/plugins/Required";
import SearcherMaterialCategory from "@/components/plugins/SearcherMaterialCategory";
import SearcherMaterialShowCategories from "@/components/plugins/SearcherMaterialShowCategories";
import EditorUnit from "./EditorUnit";
import StandardDetail from "./StandardDetail";
import Formula from "./Formula";
import Materials from "@/api/materials";
import MaterialUnits from "@/api/material_units";
import MaterialTemplates from "@/api/material_templates";
import Templates from "@/api/templates";
import SupplierMaterials from "@/api/supplier_materials";
import StockMaterials from "@/api/stock_materials";
import Files from "@/api/files";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import DialogAlert from "@/components/plugins/DialogAlert";
import TemplatesSelectsDialog from "./TemplatesSetting";
import EditDefaultUnits from "./EditDefaultUnits";
import DialogStocks from "@/components/plugins/DialogStocks";
import ErrorShopDialog from "./ErrorShopDialog";
import Recipes from "@/api/recipes";

export default {
  name: "MaterialDetail",

  props: ["value", "mode"],

  components: {
    VEditor,
    Required,
    SearcherMaterialCategory,
    SearcherMaterialShowCategories,
    EditorUnit,
    StandardDetail,
    Formula,
    ValidationObserver,
    ValidationProvider,
    DialogAlert,
    TemplatesSelectsDialog,
    EditDefaultUnits,
    DialogStocks,
    ErrorShopDialog,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new" || this.mode == "clone";
    },
    isNew() {
      return this.mode == "new" || this.mode == "clone";
    },
    headers: () => [
      {
        text: i18n.t("SupplierMaterials.Fields.suppllier"),
        align: "start",
        sortable: false,
        value: "supplier.supplier_name",
      },
      {
        text: i18n.t("SupplierMaterials.Fields.unit_order"),
        align: "center",
        sortable: false,
        value: "standard_detail.unit",
      },
      {
        text: i18n.t("SupplierMaterials.Fields.supply_price"),
        align: "end",
        sortable: false,
        value: "supply_price",
      },
      {
        text: i18n.t("SupplierMaterials.Fields.tax_flg"),
        align: "center",
        sortable: false,
        value: "tax_flg",
      },
      {
        text: i18n.t("SupplierMaterials.Fields.tax_setting"),
        align: "center",
        sortable: false,
        value: "tax_setting",
      },
      {
        text: i18n.t("SupplierMaterials.Fields.setting_default_supplier"),
        align: "start",
        sortable: false,
        value: "default_supplier_flg",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
        width: 150
      },
    ],
    materialStocksHeaders: () => [
      {
        text:
          i18n.t("Material.Fields.stock_code") +
          " / " +
          i18n.t("Material.Fields.stock_name"),
        align: "start",
        sortable: false,
        value: "stock.name",
      },
      {
        text: i18n.t("Stock.Fields.type"),
        align: "center",
        sortable: false,
        value: "stock.type",
      },
      {
        text: i18n.t("StockMaterials.Fields.unit"),
        align: "center",
        sortable: false,
        value: "unit",
      },
      {
        text: i18n.t("StockMaterials.Fields.current_stock"),
        align: "end",
        sortable: false,
        value: "current_count",
      },
      {
        text: i18n.t("StockMaterials.Fields.stock_max_and_min_num"),
        align: "center",
        sortable: false,
        value: "stock_max",
      },
      {
        text: i18n.t("StockMaterials.Fields.peeling"),
        align: "start",
        sortable: false,
        value: "peeling",
      },
      {
        text: i18n.t("StockMaterials.Fields.usable"),
        align: "start",
        sortable: false,
        value: "status",
      },
    ],
    foodFormulasHeaders: () => [
      {
        text: i18n.t("Recipes.Fields.recipe_code"),
        align: "start",
        sortable: false,
        value: "formula_code",
      },
      {
        text: i18n.t("Recipes.Fields.recipe_name"),
        align: "start",
        sortable: false,
        value: "formula_name",
      },
      {
        text: i18n.t("Recipes.Fields.status"),
        align: "start",
        sortable: false,
        value: "delete_flg",
      },
    ],
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "accountInfo"]),
  },

  mounted() {
    MaterialUnits.fetchNetUnits();
  },

  data: () => ({
    tab: null,
    serverErrors: [],
    material: {},
    materialName: "",
    material_groups: [],
    material_origins: [],
    material_brands: [],
    material_storage_conditions: [],
    material_cost_unit: [],
    templates: [],
    oldTemplates: [],
    editUnit: false,
    addUnit: null,
    viewDetailUnit: false,
    currentDetailUnit: null,
    combineFormulaDialog: false,
    splitFormulaDialog: false,
    imgRules: [
      (value) =>
        !value || value.size < 5000000 || i18n.t("Material.imgSquareHint"),
    ],
    material_img: "",
    material_img_file: null,
    imgsRules: [
      (value) =>
        !value ||
        value.filter((v) => v.size >= 10000000).length == 0 ||
        i18n.t("Material.imgsHint"),
    ],
    material_album: [],
    material_imgs_file: [],
    options: {},
    paging: {},
    supplierMaterials: [],
    settingDefaultSupplierDialog: false,
    settingDefaultSupplierMsg: "",
    settingDefaultSupplierDetail: null,
    templatesDialog: false,
    newMaterialBindTemplatesDialog: false,
    newMaterialBindTemplatesMsg: "",
    editMaterial: {},
    isUploading: false,
    EditDefaultUnitsFlg: false,
    stocks_dialog: false,
    stocks: [],
    backFlg: false,
    dialogOpenFlg: false,
    templatesMaterial: {},
    codeEditFlg: false,
    errorDataDialog: false,
    error_data: [],
    costUnitEditFlg: false,
    foodFormulasDialog: false,
    costUnitCheckData: {},
    materialStocks: [],
    materialStocksOptions: {},
    materialStocksPaging: {},
    material_video: "",
    material_video_file: null,
  }),

  watch: {
    isView: {
      immediate: true, //初始赋值也调用
      handler() {
        if (!this.isView) {
          this.tab = 0;
          this.isUploading = false;
        }
      },
    },
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.tab = 0;
        this.EditDefaultUnitsFlg = false;
        this.dialogOpenFlg = false;
        this.codeEditFlg = false;
        this.costUnitEditFlg = false;
        Materials.fetchFiledSelects({
          field_names: [
            "material_group",
            "origin",
            "brand",
            "storage_conditions",
            "cost_unit",
          ],
        }).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.material_groups = response.data.material_group;
              this.material_origins = response.data.origin;
              this.material_brands = response.data.brand;
              this.material_storage_conditions =
                response.data.storage_conditions;
              this.material_cost_unit = response.data.cost_unit;
            }
          }.bind(this)
        );
        if (this.value && this.value.id) {
          Materials.fetchOne(this.value.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.material = response.data.material;
                if (this.mode == "clone") {
                  this.material.id = 0;
                  this.material.standard.standard_details = []; // 不复制单位
                }
                if (!this.material.net_rate) {
                  this.material.net_rate = 100;
                }
                if (!this.material.yield) {
                  this.material.yield = 100;
                }
                this.material_img = this.material.material_img;
                if (this.settings && this.settings.material_video) {
                  this.material_video = this.material.material_video_url;
                }
                this.material_album = this.material.material_album
                  ? JSON.parse(JSON.stringify(this.material.material_album))
                  : [];
              }
            }.bind(this)
          );
          this.getSupplierMaterialsFromAPI();
          this.getMaterialStocksFromAPI();
          this.getTemplates(this.value.id);
        } else {
          // 新建商品，初始化默认值
          this.material = {
            standard: {
              default_standard_detail: {},
              standard_details: [],
            },
            stock_batch_rule_type: 1,
            hide_flg: 0,
            alcohol_flg: 0,
            public_flg: 1,
            in_price: 0.0,
            supply_price: 0.0,
            multiple: 0,
            min: 0,
            max: 0,
            templates: [],
            raw_material_flg: 0,
            cost_unit: "",
            cost_unit_rate: "",
          };
          this.templates = [];
          this.oldTemplates = [];
          this.material_img = "";
          this.material_video = "";
          this.material_img_file = null;
          this.material_album = [];
          this.material_imgs_file = [];
          this.isUploading = false;
        }
        this.$scrollTop(); //返回顶部
      },
    },
    options: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value && this.value.id) this.getSupplierMaterialsFromAPI();
      },
    },
    materialStocksOptions: {
      immediate: true, //初始赋值也调用
      handler() {
        if (this.value && this.value.id) this.getMaterialStocksFromAPI();
      },
    },
    materialName: {
      handler() {
        if (this.material.material_name != this.materialName) {
          //修改过才响应
          this.material.material_name = this.materialName;
          Materials.getPinyin(this.materialName).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.material.pinyin = response.data.pinyin;
              }
            }.bind(this)
          );
        }
      },
    },
    material: {
      handler() {
        this.serverErrors = []; //重置远端错误提示
        // 重设数据
        this.materialName = this.material.material_name;
        this.editUnit = this.isNew;
        var node = null;
        // 清理旧数据
        node = document.getElementById("material-video");
        if (node)
          node.childNodes.forEach((child) => {
            node.removeChild(child);
          });
        node = document.getElementById("material-comment");
        if (node)
          node.childNodes.forEach((child) => {
            node.removeChild(child);
          });
        // 设置新数据
        if (this.material.video) {
          node = document.getElementById("material-video");
          if (node)
            node.append(
              new DOMParser().parseFromString(this.material.video, "text/html")
                .body.childNodes[0]
            );
        }
        if (this.material.comment) {
          node = document.getElementById("material-comment");
          if (node)
            node.append(
              new DOMParser().parseFromString(
                this.material.comment,
                "text/html"
              ).body.childNodes[0]
            );
        }
      },
    },
    material_img: {
      handler() {
        if (!this.material_img) {
          this.material_img_file = null;
        }
      },
    },
    material_video: {
      handler() {
        if (!this.material_video) {
          this.material_video_file = null;
        }
      },
    },
    material_img_file: {
      handler() {
        if (this.material_img_file) {
          this.isUploading = true;
          // 检查一下图片上传的error，拒绝上传
          if (this.$refs.material_img_file.hasError) {
            this.isUploading = false;
            return;
          }
          Files.imageUpload(this.material_img_file, true)
            .then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.material.material_img = response.data.data.img_name;
                  this.material.thumbnail = response.data.data.thumbnail;
                  this.material_img = response.data.data.img_url;
                  this.isUploading = false;
                  this.material_img_file = null;
                }
              }.bind(this)
            )
            .catch(
              function () {
                this.isUploading = false;
              }.bind(this)
            );
        }
      },
    },
    material_video_file: {
      handler() {
        if (this.material_video_file) {
          this.isUploading = true;
          // 检查一下图片上传的error，拒绝上传
          if (this.$refs.material_video_file.hasError) {
            this.isUploading = false;
            return;
          }
          Files.fileUpload(this.material_video_file, "material_video")
            .then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.material.material_video = response.data.data.file_name;
                  this.material_video = response.data.data.file_url;
                  this.isUploading = false;
                  this.material_video_file = null;
                }
              }.bind(this)
            )
            .catch(
              function () {
                this.isUploading = false;
              }.bind(this)
            );
        }
      },
    },
    material_imgs_file: {
      handler() {
        if (
          this.material_imgs_file &&
          this.material_imgs_file.length + this.material_album.length > 10
        ) {
          this.$snackbar.error(i18n.t("Material.postImgsError"));
          return;
        }
        if (this.material_imgs_file && this.material_imgs_file.length > 0) {
          this.isUploading = true;
          // 检查一下图片上传的error，拒绝上传
          if (this.$refs.material_imgs_file.hasError) {
            this.isUploading = false;
            return;
          }
          //再尝试提交图片集
          Files.imagesUpload(this.material_imgs_file, false)
            .then(
              function (response) {
                if (response.data.status.isOK()) {
                  if (!this.material.material_album || !this.material_album) {
                    this.material.material_album = [];
                    this.material_album = [];
                  }
                  response.data.data.forEach((img, i) => {
                    this.material.material_album.push(img.img_name);
                    this.material_album.splice(
                      (this.material.material_album
                        ? this.material.material_album.length
                        : 0) + i,
                      0,
                      img.img_url
                    );
                  });
                }
                this.isUploading = false;
                this.material_imgs_file = [];
              }.bind(this)
            )
            .catch(
              function () {
                this.isUploading = false;
              }.bind(this)
            );
        }
      },
    },
    editUnit: {
      handler() {
        if (!this.editUnit) {
          if (
            this.value &&
            this.value.standard &&
            this.value.standard.standard_details
          ) {
            this.material.standard.standard_details = JSON.parse(
              //确保创建新拷贝而不是指向引用
              JSON.stringify(this.value.standard.standard_details)
            );
          } else if (this.material.standard) {
            this.material.standard.standard_details = [];
          } else {
            this.material.standard = { standard_details: [] };
          }
        }
      },
    },
    addUnit: {
      handler() {
        if (this.addUnit && this.addUnit.name) {
          var newUnit = {
            default_flg: this.material.standard.standard_details.length == 0,
            unit: this.addUnit.name,
            rate: this.material.standard.standard_details.length == 0 ? 1 : "",
            new: this.material.standard.standard_details.length + 1,
            count_unit_flg: this.addUnit.count_unit_flg,
          };
          this.material.standard.standard_details.push(newUnit);
          if (newUnit.default_flg) {
            this.material.supply_standard_detail = newUnit;
            this.material.standard.default_standard_detail = newUnit;
            if (this.mode == "clone") {
              this.templates = this.templates.map((t) => {
                t.unit = this.material.standard.default_standard_detail.unit;
                return t;
              });
            }
          }
          this.addUnit = { id: 0, name: "" }; //消除显示
        }
      },
    },
  },

  methods: {
    click() {
      if (
        this.material.standard.standard_details.length &&
        typeof this.material.multiple == "number"
      ) {
        if (this.templates.length) {
          if (this.mode == "clone") {
            this.templates = this.templates.map((t) => {
              t.unit = this.material.standard.default_standard_detail.unit;
              return t;
            });
          }
          this.templatesDialog = true;
        } else {
          this.getTemplates();
        }
      } else {
        this.newMaterialBindTemplatesDialog = true;
      }
    },
    getSupplierMaterialsFromAPI() {
      if (this.$permission.permissionAllow("SupplierMaterials", "index")) {
        SupplierMaterials.fetch(
          Object.assign({}, this.options, {
            material_ids: [this.value.id],
          })
        ).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.supplierMaterials = response.data.materials.map((detail) => {
                if (detail.material.default_supplier_id == detail.supplier_id)
                  detail.default_supplier_flg = 1;
                return detail;
              });
              this.paging = response.data.paging;
            }
          }.bind(this)
        );
      }
    },
    getMaterialStocksFromAPI() {
      if (this.$permission.permissionAllow("StockMaterials", "index")) {
        StockMaterials.getMaterialStocks(
          Object.assign({}, this.materialStocksOptions, {
            material_id: this.value.id,
          })
        ).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.materialStocks = response.data.materialStocks;
              this.materialStocksPaging = response.data.paging;
            }
          }.bind(this)
        );
      }
    },
    getTemplates(material_id) {
      if (material_id) {
        MaterialTemplates.fetchByMaterial(material_id, { readonly: 1 }).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.templatesMaterial = response.data.material;
              let data = response.data.material_template_details.map(
                  (t) => {
                    if (t.status) {
                      t.disabled = true;
                    }
                    //成本百分比
                    t.cost_price_percent = this.$numberFormatter.formatWithDotNoMoreThan(Number(t.cost_price_percent) - 100, 2);
                    t.hide_flg = t.hide_flg ? t.hide_flg : 0;
                    t.supply_price = t.supply_price ? t.supply_price : 0;
                    if (this.mode == "clone") {
                      delete t.id;
                      delete t.standard_detail_id;
                    }
                    return t;
                  }
              );
              this.templates = data;
              this.oldTemplates = JSON.parse(JSON.stringify(data))

            }
          }.bind(this)
        );
      } else {
        Templates.fetchAllForSelect().then(
          function (response) {
            if (response.data.status.isOK()) {
              var templates = [];
              response.data.templates.forEach((t) => {
                if (t.id) {
                  var data = {
                    template_id: t.id,
                    material_alias: null,
                    multiple: this.material.multiple,
                    price_type: 0,
                    supply_price: this.material.supply_price,
                    hide_flg: this.material.hide_flg,
                    material_price_percent: 100,
                    cost_price_percent: 100,
                    float_up_percent: 0,
                    min_num: 0,
                    max_num: 0,
                    unit: this.material.standard.default_standard_detail.unit,
                    status:
                      this.settings && this.settings.sub_account_enable ? 0 : 0, // 开分账时默认不选中模板；不开时默认全选中
                    is_follow: false,
                    sub_account_price_json: null,
                    template: {
                      id: t.id,
                      template_name: t.template_name,
                    },
                    rate: this.material.standard.default_standard_detail.rate,
                    last_in_price: 0,
                    material_supply_price: 0,
                  };
                  if (data.status) {
                    data.disabled = true;
                  }
                  templates.push(data);
                }
              });
              this.templates = templates;
              this.oldTemplates = JSON.parse(JSON.stringify(templates))
              this.templatesDialog = true;
            }
          }.bind(this)
        );
      }
    },
    removeFromImages(i) {
      this.material_album.splice(i, 1);
      if (
        this.material.material_album &&
        i < this.material.material_album.length
      ) {
        this.material.material_album.splice(i, 1);
      }
    },
    deleteUnit(index) {
      var deletedUnit = this.material.standard.standard_details.splice(
        index,
        1
      );
      if (
        deletedUnit &&
        deletedUnit[0].default_flg && // 如果删去的是默认单位（新建商品时允许删除默认单位）
        this.material.standard.standard_details.length > 0 // 且单位还没删空
      ) {
        this.changeDefaultUnit(this.material.standard.standard_details[0]); // 将剩下的第一个单位设为默认单位
      }
    },
    changeDefaultUnit(defaultUnitItem) {
      if (!this.isNew) return;
      this.material.standard.standard_details =
        this.material.standard.standard_details.map((item) => {
          if (item.new == defaultUnitItem.new) {
            item.default_flg = 1;
            item.rate = 1;
          } else {
            item.default_flg = 0;
            item.rate = "";
          }
          return item;
        });
      this.material.standard.default_standard_detail = defaultUnitItem;
    },
    preSubmit() {
      if (
        !this.dialogOpenFlg &&
        this.isNew &&
        this.accountInfo &&
        this.accountInfo.version &&
        this.$permission.permissionAllow("StockMaterials", "batchSave") &&
        (this.accountInfo.version.stock_type == 3 ||
          (this.accountInfo.version.stock_type == 2 &&
            this.settings &&
            this.settings.distribution_district_auto_add == 1))
      ) {
        this.stocks_dialog = true;
        this.dialogOpenFlg = true;
      } else {
        this.submit(this.backFlg);
      }
    },
    submit(back) {
      //提交保存遮罩开始
      this.$store.dispatch("fullscreenLoading");
      // 检查启用的模板是否设置了分账明细，未设置不提交
      if (this.settings && this.settings.sub_account_enable) {
        var splitErr = false;
        var splitErrPercent = false;
        if (this.templates.length) {
          this.templates.forEach(
            function (t) {
              if (this.settings && this.settings.sub_account_split_type) {
                if (t.status && t.supply_price != 0) {
                  if (
                    t.sub_account_price_json == null ||
                    t.sub_account_price_json == undefined
                  ) {
                    splitErrPercent = true;
                    return;
                  }
                  var splitPercent = 0;
                  Object.keys(t.sub_account_price_json).forEach(function (sk) {
                    splitPercent += Number(
                      t.sub_account_price_json[sk].percent
                    );
                  });
                  if (
                    this.$numberFormatter.formatWithMoney(splitPercent) != 1
                  ) {
                    splitErrPercent = true;
                    return;
                  }
                }
              } else {
                if (t.status && t.supply_price != 0) {
                  if (
                    t.sub_account_price_json == null ||
                    t.sub_account_price_json == undefined
                  ) {
                    splitErr = true;
                    return;
                  }
                  var splitPrice = 0;
                  Object.keys(t.sub_account_price_json).forEach(function (sk) {
                    splitPrice += Number(t.sub_account_price_json[sk].price);
                  });
                  if (
                    this.$numberFormatter.formatWithMoney(t.supply_price) !=
                    this.$numberFormatter.formatWithMoney(splitPrice)
                  ) {
                    splitErr = true;
                    return;
                  }
                }
              }
            }.bind(this)
          );
        }
        if (splitErr) {
          this.$store.dispatch("fullscreenLoadingStop");
          this.$snackbar.error(i18n.t("Material.saveMaterialSplitErrMsg"));
          return;
        }
        if (splitErrPercent) {
          this.$store.dispatch("fullscreenLoadingStop");
          this.$snackbar.error(
            i18n.t("Material.saveMaterialSplitPercentErrMsg")
          );
          return;
        }
      }
      this.serverErrors = []; //重置远端错误提示
      this.$refs.observer.validate().then(
        async function (result) {
          if (result) {
            //校验成功再提交
            if (this.$refs.material_group)
              this.material.material_group =
                this.$refs.material_group.lazySearch;
            if (this.$refs.origin)
              this.material.origin = this.$refs.material_origin.lazySearch;
            if (this.$refs.material_brand)
              this.material.brand = this.$refs.material_brand.lazySearch;
            if (this.$refs.storage_conditions)
              this.material.storage_conditions =
                this.$refs.storage_conditions.lazySearch;
            if (this.$refs.cost_unit)
              this.material.cost_unit = this.$refs.cost_unit.lazySearch;
            if (
              this.isNew &&
              this.accountInfo &&
              this.accountInfo.version &&
              this.$permission.permissionAllow("StockMaterials", "batchSave") &&
              (this.accountInfo.version.stock_type == 3 ||
                (this.accountInfo.version.stock_type == 2 &&
                  this.settings &&
                  this.settings.distribution_district_auto_add == 1))
            ) {
              this.material.stock_ids = this.stocks
                ? this.stocks.map((stock) => {
                    return stock.id;
                  })
                : [];
              this.stocks = [];
            }
            //最后提交商品信息
            Materials.save(this.material.id, this.material)
              .then(
                function (response) {
                  if (response.data.status.isOK()) {
                    if (this.templates.length) {
                      if (this.isNew) {
                        this.templates = this.templates.map((t) => {
                          if (
                            !t.sub_account_price_json &&
                            this.settings &&
                            this.settings.sub_account_enable
                          ) {
                            delete t.supply_price;
                          }
                          return Object.assign({}, t, {
                            material_id: response.data.material.id,
                          });
                        });
                      }
                      this.saveMaterialTemplates(back);
                    } else {
                      if (back) {
                        this.$snackbar.success(
                          i18n.t("Material.saveSuccessAndCountinueToAddMsg")
                        );
                        this.material = {
                          standard: {
                            default_standard_detail: {},
                            standard_details: [],
                          },
                          stock_batch_rule_type: 1,
                          hide_flg: 0,
                          alcohol_flg: 0,
                          public_flg: 1,
                          in_price: 0.0,
                          supply_price: 0.0,
                          multiple: 0,
                          min: 0,
                          max: 0,
                          templates: [],
                          raw_material_flg: 0,
                        };
                        this.$emit("mode", "new");
                        this.$refs.observer.reset();
                      } else {
                        this.$emit("save", this.material);
                        this.$emit("mode", null);
                        this.$emit("input", null);
                      }
                      this.$store.dispatch("fullscreenLoadingStop");
                    }
                  } else if (
                    response.data.error &&
                    response.data.error.data &&
                    "ERR333" == response.data.error.code
                  ) {
                    this.serverErrors = response.data.error.data;
                    this.$store.dispatch("fullscreenLoadingStop");
                  }
                }.bind(this)
              )
              .catch(
                function () {
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    saveMaterialTemplates(back) {
      MaterialTemplates.batchSave(this.templates, 2).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (back) {
              this.$snackbar.success(
                i18n.t("Material.saveSuccessAndCountinueToAddMsg")
              );
              this.material = {
                standard: {
                  default_standard_detail: {},
                  standard_details: [],
                },
                stock_batch_rule_type: 1,
                hide_flg: 0,
                alcohol_flg: 0,
                public_flg: 1,
                in_price: 0.0,
                supply_price: 0.0,
                multiple: 0,
                min: 0,
                max: 0,
                templates: [],
                raw_material_flg: 0,
              };
              this.$emit("mode", "new");
              this.$refs.observer.reset();
            } else {
              this.$emit("save", this.material);
              this.$emit("mode", null);
              this.$emit("input", null);
            }
          }
          //提交保存遮罩结束
          this.$store.dispatch("fullscreenLoadingStop");
        }.bind(this)
      );
    },
    settingDefaultSupplier() {
      if (this.settingDefaultSupplierDetail) {
        Materials.bindDefaultSupplier({
          supplier_id: this.settingDefaultSupplierDetail.supplier_id,
          material_id: this.settingDefaultSupplierDetail.material_id,
          default_flg: this.settingDefaultSupplierDetail.default_supplier_flg
            ? 1
            : 0,
        }).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.getSupplierMaterialsFromAPI();
              this.settingDefaultSupplierDialog = false;
            }
          }.bind(this)
        );
      }
    },
    getEditDefaultUnits() {
      Materials.getEditDefaultUnits(this.value.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.EditDefaultUnitsFlg = true;
          }
        }.bind(this)
      );
    },
    checkEditAndDelete() {
      Materials.checkEditAndDelete(this.value.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.error_data = [];
            this.error_psi_stock_take = response.data.error_psi_stock_take;
            this.error_psi_stock_out_order =
              response.data.error_psi_stock_out_order;
            this.error_psi_stock_in_order =
              response.data.error_psi_stock_in_order;

            if (
              this.error_psi_stock_take.length ||
              this.error_psi_stock_out_order.length ||
              this.error_psi_stock_in_order.length
            ) {
              if (this.error_psi_stock_take.length) {
                this.error_data.push({
                  identify_name: i18n.t("Material.Fields.stock_take"),
                  errorShop: this.error_psi_stock_take,
                });
              }
              if (this.error_psi_stock_out_order.length) {
                this.error_data.push({
                  identify_name: i18n.t("Material.Fields.stock_out_order"),
                  errorShop: this.error_psi_stock_out_order,
                });
              }
              if (this.error_psi_stock_in_order.length) {
                this.error_data.push({
                  identify_name: i18n.t("Material.Fields.stock_in_order"),
                  errorShop: this.error_psi_stock_in_order,
                });
              }
              this.errorDataDialog = true;
            } else {
              this.codeEditFlg = true;
            }
          }
        }.bind(this)
      );
    },
    checkEditCostUnit(type) {
      if (this.mode == "new" || this.mode == "clone") {
        if (type == "word") {
          this.costUnitEditFlg = true;
          this.material.cost_unit =
            this.material.standard.default_standard_detail.unit;
          this.material.cost_unit_rate = 1;
        }
      } else {
        Materials.checkEditCostUnit(this.value.id).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.costUnitCheckData = {};
              this.costUnitCheckData = response.data;
              if (type == "word") {
                if (this.costUnitCheckData.edit_flg) {
                  this.costUnitEditFlg = true;
                  this.material.cost_unit =
                    this.material.standard.default_standard_detail.unit;
                  this.material.cost_unit_rate = 1;
                }
              } else if (type == "editPen") {
                if (this.costUnitCheckData.edit_flg) {
                  this.costUnitEditFlg = true;
                }
              }
              if (
                this.costUnitCheckData.food_formulas &&
                this.costUnitCheckData.food_formulas.length
              ) {
                this.foodFormulasDialog = true;
              }
            }
          }.bind(this)
        );
      }
    },
    foodFormulasDel() {
      Recipes.batchDeleteForMaterials(this.value.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.foodFormulasDialog = false;
            this.$snackbar.success(
              i18n.t("Recipes.Fields.batch_delete_success")
            );
          }
        }.bind(this)
      );
    },
    downloadAlbumImgs() {
      let _this = this;
      for (let i = 0; i < _this.material_album.length; i++) {
        const iframe = document.createElement("iframe");
        iframe.style.display = "none"; // 防止影响页面
        iframe.style.height = 0; // 防止影响页面
        iframe.src = _this.material_album[i];
        document.body.appendChild(iframe);
        setTimeout(() => {
          iframe.remove();
        }, 1000);
      }
    },
    resetTemplates() {
      this.templates = JSON.parse(JSON.stringify(this.oldTemplates))
    },
  },
};
</script>